import api from '@/api';

class ClientActionType {
  static list() {
    return api.get('/actions/client-action-types');
  }
}

export default ClientActionType;
